import React from "react";
import BestProducts from "../components/Best";
import { useEffect } from "react";

function Best() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Best Products";
  }, []);
  return (
    <div>
      <BestProducts />
    </div>
  );
}

export default Best;
